<template>
  <nav class="navbar is-transparent is-primary">
    <div class="navbar-brand">
      <a class="navbar-item kolibri-logo" target="_blank" rel="noopener" :href="$store.isTestnet ? 'https://testnet.kolibri.finance' : 'https://kolibri.finance'">
        <img src="../assets/kolibri-logo-white.svg">
      </a>
      <div @click="menuShown = !menuShown" class="navbar-burger" :class="{'is-active': menuShown}">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu" :class="{'is-active': menuShown}">
      <div class="navbar-start">

      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div v-if="$store.wallet === null" class="field is-grouped">
            <div class="control">
              <router-link target="_blank" :to="{name: 'PaymentVaults'}" class="button is-white is-outlined">
                <b>Payment Vaults</b>
              </router-link>
            </div>
            <div class="control">
              <button @click="$eventBus.$emit('wallet-connect')" class="button is-white is-outlined">
                <b>Connect Wallet</b>
              </button>
            </div>
          </div>
          <div v-else class="field is-grouped">
            <div class="control">
              <router-link target="_blank" :to="{name: 'PaymentVaults'}" class="button is-white is-outlined">
                <b>Payment Vaults</b>
              </router-link>
            </div>
            <div class="control">
              <div class="tiny-info-holder">
                <div v-if="$store.currentkDAOHoldings === null" class="loader"></div>
                <b v-else>{{ $store.currentkDAOHoldings.dividedBy(Math.pow(10,18)).toNumber().toLocaleString() }} kDAO</b>
              </div>
            </div>
            <div class="control">
              <div class="tiny-info-holder">
                <a @click="$eventBus.$emit('wallet-reconnect')" class="has-text-weight-bold has-text-white">{{ truncateChars($store.walletAddress, 12) }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data(){
    return {
      menuShown: false,
    }
  },
  methods: {
    truncateChars(fullStr, strLen, separator) {
      if (fullStr.length <= strLen) return fullStr;

      separator = separator || '...';

      let sepLen = separator.length,
        charsToShow = strLen - sepLen,
        frontChars = Math.ceil(charsToShow/2),
        backChars = Math.floor(charsToShow/2);

      return fullStr.substr(0, frontChars) +
        separator +
        fullStr.substr(fullStr.length - backChars);
    },
  },
  computed:{
  }
}
</script>

<style lang="scss">
@import '../assets/sass/globals';
.navbar{
  .navbar-menu{
    @include until($tablet){
      border-bottom: 1px solid white;
      border-top: 1px solid white;
      background: $primary;
    }
  }
  .kolibri-logo{
    transition: transform .3s ease;
    &:hover{
      transform: scale(1.1);
    }
  }
  .tiny-info-holder{
    width: 9.125rem;
    height: 2.5rem;
    color: white;
    border: 1px solid white;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
